import { component as defineComponent } from 'flightjs';

const breakpointBroadcaster = function () {
    this.after('initialize', function () {
        this.on(document, 'media-query:match', this.broadcastChange);
    });

    this.broadcastChange = function (e, breakpoint) {
        this.$node.trigger('uiBreakpointChanged', breakpoint);
    };
};

export default defineComponent(breakpointBroadcaster);



// WEBPACK FOOTER //
// ./src/web/js/app/ui/breakpoint-broadcaster.js